import axios from "axios";
import { getDateRange } from "src/modules/data-summary/utils/date-utils";

export const getSummaryScanData = async (
  filters,
  page = 0,
  itemPerPage = 25,
  additionalInfoColumns = [],
  displayLang = "EN"
) => {
  try {
    const start = page * itemPerPage;
    const params = {
      company_id: filters.company,
      length: itemPerPage,
      start,
    };

    // Add additional info columns if provided
    if (additionalInfoColumns && additionalInfoColumns.length > 0) {
      params.additional_info_columns = additionalInfoColumns;
      params.display_lang = displayLang;
    }

    // Handle branch selection (support both single and multiple selections)
    if (filters.branch && filters.branch !== "ALL") {
      // If branch is not ALL, ensure it's treated as an array for the API
      const branchValues = Array.isArray(filters.branch)
        ? filters.branch
        : [filters.branch];

      const filteredBranches = branchValues.filter((val) => val !== "ALL");

      if (filteredBranches.length > 0) {
        params.branch_id = filteredBranches;
      }
    }
    if (filters.product && filters.product !== "ALL") {
      const productValues = Array.isArray(filters.product)
        ? filters.product
        : [filters.product];

      // Filter out "ALL" if it got mixed in somehow
      const filteredProducts = productValues.filter((val) => val !== "ALL");

      // Only add product_uuid param if there are actual product selections
      if (filteredProducts.length > 0) {
        params.product_uuid = filteredProducts;
      }
    }
    if (
      filters.filterMode === "By Date" &&
      filters.startDate &&
      filters.endDate
    ) {
      params.start_date = filters.startDate;
      params.end_date = filters.endDate;
    } else {
      const { startDate, endDate } = getDateRange({
        year: filters.year,
        month: filters.month,
      });
      params.start_date = startDate;
      params.end_date = endDate;
    }

    const { data } = await axios.get(
      "/consumer/system-admin/api/v1/data-summary/scan-track-summary",
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (data.success && data.data?.records) {
      const records = [...data.data.records];
      const additionalInfoMeta = data.data?.additionalInfoMeta || [];

      const transformedData = records.map((record) => {
        const baseRecord = {
          companyName: record.company_name,
          scanDateTime: record.scan_date_time,
          serialNumber: record.serial_number,
          branch: record.branch_name || "N/A",
          ipAddress: record.ip_address,
          location: record.location,
          googleMapLink: record.google_map_link,
          latitude: record.latitude,
          longitude: record.longitude,
          os: record.os,
          browser: record.browser,
          deviceType: record.device_type,
          scanCount: record.scan_count,
          scanLimit: record.scan_limit,
          productName: record.product_name || "Unknown Product",
          productUuid: record.product_uuid || "Unknown Product",
          status: record.status,
        };

        // Add additional info fields to the record
        additionalInfoMeta.forEach((meta) => {
          baseRecord[meta.key] = record[meta.key] || "";
        });

        return baseRecord;
      });

      return {
        success: true,
        data: transformedData,
        total: data.data?.total || 0,
        filtered: data.data?.filtered || transformedData.length,
        additionalInfoMeta,
      };
    }

    return data;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    throw errorResponse;
  }
};

export default getSummaryScanData;
